import { render, staticRenderFns } from "./gift-pack-list.vue?vue&type=template&id=c5290b8a&scoped=true&"
import script from "./gift-pack-list.vue?vue&type=script&lang=js&"
export * from "./gift-pack-list.vue?vue&type=script&lang=js&"
import style0 from "./gift-pack-list.vue?vue&type=style&index=0&id=c5290b8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5290b8a",
  null
  
)

export default component.exports